<template>
  <div>
    <div :style="`max-height: ${height}px`" class="show-more-outer overflow-y">
      <slot></slot>
    </div>
    <a href="#"
      v-on:click.prevent="showAll"
      v-if="!hideLink"
      class="dashed-link my-2 d-inline-block"
    >{{ height === defaultHeight ? 'Show more' : 'Show less' }}</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: 0
    }
  },
  props: {
    defaultHeight: {
      type: Number,
      default: 100
    },
    hideLink: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.height = this.defaultHeight
  },
  methods: {
    showAll() {
      if (this.height === this.defaultHeight) {
        this.height = 3000
      } else {
        this.height = this.defaultHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

.show-more-outer{
  transition: 1s max-height;
}
</style>
